/* =============================================================================
   TBO CRO PACK 2 - 2026-09-09 ("luxe, curated, low-click" build)
   Six independent, guarded modules. A failure in one cannot take down the
   others. None touch checkout. Loaded from snippets/tbo-cro-0829.liquid.
   Rollback = delete its script line there.

   2026-09-09 HOTFIX: module 3 previously wrote into the same drawer its
   MutationObserver watched (infinite loop, pegged main thread). Fixed with
   content-diff guards + coalesced scheduling.
   2026-09-09 PM: module 3 renders NOTHING when no ZIP is saved - the drawer
   carries its own ZIP checker, so a line saying "check your ZIP on any
   product page" directly above an actual ZIP input was redundant.
   2026-09-10: a 7th module (cart-link safety net) was drafted here and then
   MOVED OUT to snippets/tbo-cart-fallback.liquid. It has to run in the
   bubble phase during the initial parse to read e.defaultPrevented after
   the drawer's own handler; from this deferred bundle, in capture phase,
   the flag was always false and it silently never fired. Do not re-add it
   here - see that snippet's header.

     1. SHORT CARD TITLES on Searchanise grids (Dawn cards are done in Liquid)
     2. IN-STOCK FIRST ordering on Dawn grids + homepage collection rows
     3. CART DRAWER shipping-eligibility line (reads TBO.* from tbo-ship-data)
     4. PDP DELIVERY ESTIMATE from the saved ZIP (localStorage tbo_ship_zip)
     5. "SENDING AS A GIFT?" collapse for the PDP add-on checkboxes
     6. MOBILE CATEGORY CHIPS under the header search bar
   ============================================================================= */
(function () {
  'use strict';

  function log(area, err) {
    if (window.console && console.warn) console.warn('[tbo-cro2] ' + area, err);
  }

  /* ---------------------------------------------------------------------------
     1. SHORT CARD TITLES - Searchanise (snize) grids
  --------------------------------------------------------------------------- */
  try {
    var TITLE_SEL = '.snize-title, .snize-product-title, a.snize-view-link .snize-title';

    function shortenTitles(root) {
      var nodes = (root || document).querySelectorAll(TITLE_SEL);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.getAttribute('data-tbo-short') === '1') continue;
        var full = (el.textContent || '').trim();
        var cut = full.indexOf(',');
        if (cut > 8) {
          el.setAttribute('title', full);
          el.textContent = full.slice(0, cut);
        }
        el.setAttribute('data-tbo-short', '1');
      }
    }

    var snizeDebounce = null;
    var mo = new MutationObserver(function () {
      clearTimeout(snizeDebounce);
      snizeDebounce = setTimeout(function () {
        try { shortenTitles(document); } catch (e) { log('titles', e); }
      }, 150);
    });
    document.addEventListener('DOMContentLoaded', function () {
      shortenTitles(document);
      mo.observe(document.body, { childList: true, subtree: true });
    });
  } catch (e) { log('titles-init', e); }

  /* ---------------------------------------------------------------------------
     2. IN-STOCK FIRST. Collection pages AND homepage featured-collection rows.
        Sold-out cards move to the end of their row and dim; never hidden
        (allocated bottles stay visible for SEO + waitlist by policy).
  --------------------------------------------------------------------------- */
  try {
    function reorderList(list) {
      if (list.getAttribute('data-tbo-stockfirst') === '1') return;
      list.setAttribute('data-tbo-stockfirst', '1');
      if (list.querySelector('[class*="snize"]')) return;
      var items = Array.prototype.slice.call(list.children);
      if (items.length < 2 || items.length > 16) return;
      var soldOutRe = new RegExp('sold' + String.fromCharCode(92) + 's*out', 'i');
      var sold = items.filter(function (li) {
        var badge = li.querySelector('.card__badge .badge');
        return badge && soldOutRe.test(badge.textContent || '');
      });
      if (!sold.length || sold.length === items.length) return;
      sold.forEach(function (li) {
        li.style.opacity = '0.62';
        list.appendChild(li);
      });
    }
    function stockFirst() {
      var lists = document.querySelectorAll('#product-grid, ul.grid.product-grid');
      for (var i = 0; i < lists.length; i++) {
        try { reorderList(lists[i]); } catch (e) { log('stockfirst-item', e); }
      }
    }
    document.addEventListener('DOMContentLoaded', function () {
      try { stockFirst(); } catch (e) { log('stockfirst', e); }
    });
  } catch (e) { log('stockfirst-init', e); }

  /* ---------------------------------------------------------------------------
     3. CART DRAWER eligibility line. Content-diffed writes (loop guard).
        Renders only when a ZIP is saved; the drawer's own ZIP checker
        handles the no-ZIP case.
  --------------------------------------------------------------------------- */
  try {
    function drawerEligibility() {
      var T = window.TBO;
      var footer = document.querySelector('.cart-drawer .drawer__footer');
      if (!footer) return;

      var html = '';
      var color = 'rgba(0,0,0,.72)';
      if (T && typeof T.getZip === 'function') {
        var zip = T.getZip();
        if (zip) {
          var v = null;
          try { v = T.checkZip(zip); } catch (e) { v = null; }
          if (v && v.blocked) {
            html = '&#9888;&#65039; We can&rsquo;t ship alcohol to <strong>' + zip + '</strong>' + (v.state ? ' (' + v.state + ')' : '') + '. Local pickup in Whittier, CA is available.';
            color = '#a4001e';
          } else {
            html = '&#10003; Ships to <strong>' + zip + '</strong>' + (v && v.state ? ' &middot; ' + v.state : '') + ' &middot; adult signature on delivery';
          }
        }
      }

      var line = document.getElementById('tbo-drawer-elig');
      if (!line) {
        if (!html) return;
        line = document.createElement('div');
        line.id = 'tbo-drawer-elig';
        line.setAttribute('data-cro-id', 'drawer-eligibility');
        line.style.cssText = 'font-size:1.25rem;line-height:1.4;padding:.7rem 0 .2rem;';
        footer.insertBefore(line, footer.firstChild);
      }
      if (line.getAttribute('data-tbo-html') === html) return;
      line.setAttribute('data-tbo-html', html);
      line.style.color = color;
      line.style.display = html ? '' : 'none';
      line.innerHTML = html;
    }

    var eligScheduled = false;
    function scheduleEligibility() {
      if (eligScheduled) return;
      eligScheduled = true;
      setTimeout(function () {
        eligScheduled = false;
        try { drawerEligibility(); } catch (e) { log('drawer', e); }
      }, 200);
    }

    document.addEventListener('DOMContentLoaded', scheduleEligibility);
    document.addEventListener('tbo:cart:updated', scheduleEligibility);
    document.addEventListener('tbo:zip-changed', scheduleEligibility);
    document.addEventListener('DOMContentLoaded', function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      new MutationObserver(scheduleEligibility).observe(drawer, { childList: true, subtree: true });
    });
  } catch (e) { log('drawer-init', e); }

  /* ---------------------------------------------------------------------------
     4. PDP DELIVERY ESTIMATE. Ranges only, never a promised date. Hidden on
        gift cards and blocked ZIPs. Content-diffed like module 3.
  --------------------------------------------------------------------------- */
  try {
    var LANE_PREFIXES = /^(7[5-9]|8[5-6]|8[7-8]|889|89[0-8]|9[0-6]|97|9[8-9]|83[2-8])/;

    function addBizDays(date, n) {
      var d = new Date(date.getTime());
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) n--;
      }
      return d;
    }
    function fmt(d) {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    function pdpEta() {
      var T = window.TBO;
      if (!T || typeof T.getZip !== 'function') return;
      var buyBox = document.querySelector('.product-form__buttons');
      if (!buyBox) return;
      if (document.querySelector('.tbo-giftcard-page, [data-tbo-giftcard]')) return;
      var zip = T.getZip();
      var host = document.getElementById('tbo-pdp-eta');
      if (!zip) { if (host) host.remove(); return; }
      var v = null;
      try { v = T.checkZip(zip); } catch (e) { return; }
      if (!v || v.blocked) { if (host) host.remove(); return; }

      var west = LANE_PREFIXES.test(zip);
      var today = new Date();
      var early = addBizDays(today, west ? 2 : 4);
      var late = addBizDays(today, west ? 4 : 7);

      if (!host) {
        host = document.createElement('div');
        host.id = 'tbo-pdp-eta';
        host.setAttribute('data-cro-id', 'pdp-eta');
        host.style.cssText = 'font-size:1.3rem;line-height:1.4;margin:.6rem 0 .2rem;color:rgba(0,0,0,.78);';
        buyBox.parentNode.insertBefore(host, buyBox);
      }
      var html = '&#128666; Estimated arrival <strong>' + fmt(early) + '&ndash;' + fmt(late) + '</strong> to ' + zip + ' <span style="opacity:.65">&middot; adult signature required</span>';
      if (host.getAttribute('data-tbo-html') === html) return;
      host.setAttribute('data-tbo-html', html);
      host.innerHTML = html;
    }

    document.addEventListener('DOMContentLoaded', pdpEta);
    document.addEventListener('tbo:zip-changed', pdpEta);
  } catch (e) { log('eta-init', e); }

  /* ---------------------------------------------------------------------------
     5. "SENDING AS A GIFT?" COLLAPSE. Folds .add-on-product-options behind one
        row. Skips the gift card PDP (tbo-giftcard-pdp.liquid hides the block).
  --------------------------------------------------------------------------- */
  try {
    function giftCollapse() {
      var box = document.querySelector('.add-on-product-options');
      if (!box || box.getAttribute('data-tbo-collapsed') === '1') return;
      if (window.getComputedStyle(box).display === 'none') return;
      box.setAttribute('data-tbo-collapsed', '1');

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.setAttribute('data-cro-id', 'gift-collapse-toggle');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.style.cssText = 'display:flex;align-items:center;gap:.6rem;width:100%;max-width:460px;margin:0 0 12px;padding:10px;border:1px solid rgba(0,0,0,.15);border-radius:6px;background:#fff;color:#52514e;font-size:14px;line-height:1.35;text-align:left;cursor:pointer;font-family:inherit;';
      toggle.innerHTML = '<span aria-hidden="true">&#127873;</span><b style="color:#0b0b0b">Sending as a gift?</b><span style="opacity:.65">Wrap, card or expedite</span><span style="margin-left:auto" aria-hidden="true">+</span>';

      var heading = box.querySelector(':scope > span');
      if (heading) heading.style.display = 'none';
      box.style.display = 'none';
      box.parentNode.insertBefore(toggle, box);

      toggle.addEventListener('click', function () {
        var open = box.style.display !== 'none';
        box.style.display = open ? 'none' : 'block';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.lastElementChild.textContent = open ? '+' : String.fromCharCode(8722);
      });
    }
    document.addEventListener('DOMContentLoaded', giftCollapse);
  } catch (e) { log('gift-init', e); }

  /* ---------------------------------------------------------------------------
     6. MOBILE CATEGORY CHIPS - horizontally scrollable row directly under the
        header search bar on viewports below 990px.
  --------------------------------------------------------------------------- */
  try {
    function mobileChips() {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      if (document.getElementById('tbo-mobile-chips')) return;
      var anchor = document.querySelector('.mobile-custom-search');
      if (!anchor) return;
      var CHIPS = [
        ['Best Sellers', '/collections/best-selling-collection'],
        ['Rare', '/collections/rare'],
        ['Bourbon', '/collections/bourbon-whiskey'],
        ['Tequila', '/collections/tequila'],
        ['Beer', '/collections/beer'],
        ['Gifts', '/collections/spirits-gifts']
      ];
      var row = document.createElement('nav');
      row.id = 'tbo-mobile-chips';
      row.setAttribute('aria-label', 'Shop categories');
      row.setAttribute('data-cro-id', 'mobile-chips');
      row.style.cssText = 'display:flex;gap:8px;overflow-x:auto;-webkit-overflow-scrolling:touch;padding:6px 15px 10px;scrollbar-width:none;';
      row.innerHTML = CHIPS.map(function (c) {
        return '<a href="' + c[1] + '" data-cro-id="mchip-' + c[0].toLowerCase().replace(/[^a-z]+/g, '-') + '" style="flex:0 0 auto;display:inline-flex;align-items:center;min-height:38px;padding:0 16px;border:1px solid rgba(0,0,0,.18);border-radius:999px;background:#faf8f3;color:#1a1a1a;font-size:13px;text-decoration:none;white-space:nowrap;">' + c[0] + '</a>';
      }).join('');
      anchor.parentNode.insertBefore(row, anchor.nextSibling);
    }
    document.addEventListener('DOMContentLoaded', mobileChips);
  } catch (e) { log('chips-init', e); }
})();